<template>
  <div :class="['language-selector', state, hover, className]" @mouseover="handleMouseOver" @mouseout="handleMouseOut"
    @click="activate">
    <div class="language">{{ abbr }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref } from 'vue'

export default defineComponent({
  name: 'LanguageSelector',
  props: {
    abbr: {
      type: String,
    },
    state: {
      type: String as PropType<'inactive' | 'active'>,
      default: 'inactive'
    },
    hover: {
      type: String as PropType<'inactive' | 'hover'>,
      default: 'inactive'
    },
    className: {
      type: String,
      default: ''
    }
  },
  emits: ['activate', 'handleMouseOver', 'handleMouseOut'],
  setup(props, { emit }) {
    const currentState = ref(props.state)
    const hoverState = ref(props.hover)
    const setMode = (mode: 'inactive' | 'active') => {
      currentState.value = mode
    }

    const setHoverState = (mode: 'inactive' | 'hover') => {
      hoverState.value = mode
    }

    const handleMouseOver = () => {
      emit('handleMouseOver', props.abbr)
      if (currentState.value !== 'active') {
        setHoverState('hover')
      }
    }

    const handleMouseOut = () => {
      emit('handleMouseOut', props.abbr)
      if (currentState.value !== 'active') {
        setHoverState('inactive')
      }
    }

    const activate = () => {
      emit('activate', props.abbr)
      setMode('active')
    }

    return {
      currentState,
      hoverState,
      setMode,
      handleMouseOver,
      handleMouseOut,
      activate
    }
  }
})
</script>

<style scoped>
.language-selector {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 2px 4px;
  position: relative;
}

.language-selector .language {
  align-self: stretch;
  font-size: 16px;
  letter-spacing: -0.32px;
  margin-top: 2px;
  position: relative;
}

.language-selector.hover {
  background-color: var(--app-yellow);
}

.language-selector.active {
  background-color: var(--app-yellow);
  color: var(--app-black);
}

.language-selector.hover .language {
  color: var(--app-black);
  font-family: 'Antarlida', sans-serif;
  font-weight: 400;
}

.language-selector.inactive .language {
  font-family: 'Antarlida', sans-serif;
  font-weight: 400;
}

.language-selector.active .language {
  font-family: 'Antarlida', sans-serif;
  font-weight: 600;
}
</style>
